import { createAction, props } from '@ngrx/store';

export const setGreenhouseNoticeVisibility = createAction(
  '[Greenhouse] Set greenhouse notice visibility',
  props<{ visible: boolean }>(),
);
